import { FadeIn } from './fade-in';

import { cn } from '~/lib/utils';

interface ProductFeatureBlockProps {
  code: string;
  label: string;
  title: string;
  className?: string;
}

export const ProductFeatureBlock = ({
  code,
  label,
  title,
  className,
}: ProductFeatureBlockProps) => {
  return (
    <section
      className={cn(
        'w-full bg-graphite-dark px-4 md:px-20 pt-5 pb-10 md:pt-10 md:pb-20 flex flex-col gap-2.5 items-end text-white',
        className
      )}
    >
      <FadeIn>
        <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase text-right w-full">
          {code}
        </p>
      </FadeIn>
      <FadeIn delay={0.1} className='w-full'>
        <div className="flex flex-col gap-3 w-full">
          <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase">
            {label}
          </p>
          <p className="text-xl font-normal whitespace-pre-line">{title}</p>
        </div>
      </FadeIn>
    </section>
  );
};
